module.exports = __webpack_public_path__ + "img/17.87d31900.png";